
import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { ButtonModule } from 'primeng/button';


@Component({
  selector: 'no-bookings',
  templateUrl: './no-bookings.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [ButtonModule, TranslateModule]
})
export class NoBookingsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}